import { Controller } from "@hotwired/stimulus"

// data-controller="admin-event-filter-checkbox"
export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    // Якщо немає жодного вибраного — вибрати перші два
    this.ensureDefaultSelection()
  }

  checkboxChanged(event) {
    const checked = this.checkedBoxes()

    console.log(`Checked boxes: ${checked.length}`)
    if (checked.length === 0) {
      // Якщо всі зняли — вибрати інший чекбокс
      this.selectAnother(event.target)
    }
  }

  ensureDefaultSelection() {
    const checked = this.checkedBoxes()
    if (checked.length < 2) {
      this.checkboxTargets.forEach((cb, i) => {
        cb.checked = i < 2
      })
    }
  }

  checkedBoxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }

  selectAnother(deselected) {
    const other = this.checkboxTargets.find(cb => cb !== deselected)
    if (other) other.checked = true
  }
}
